module.exports = __webpack_public_path__ + "img/man-winner.800691b3.png";